export function filterImg(string) {
  var a = string
  var arrimg = []
  a.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (
    match,
    capture
  ) {
    arrimg.push(capture)
  })
  if (arrimg != null && arrimg.length > 0) {
    return arrimg
  }
}


// WEBPACK FOOTER //
// ./src/utils/filterImg.js